import { api } from './api';
import { unauthorizedError } from './state';

export const getPremiumSettings = () => (dispatch) => {
  return api
    .get('/config/all')
    .then((response) => {
      dispatch({ type: 'GET_PREMIUM_SETTINGS', data: response.data });
    })
    .catch(function (error) {
      dispatch({ type: 'GET_PREMIUM_SETTINGS_ERROR' });
      alert(error);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
      return [];
    });
};

export const updatePremiumSetting = (key, value) => (dispatch) => {
  return api
    .put('/config/' + key, { data: value })
    .then((response) => {
      dispatch({ type: 'UPDATE_PREMIUM_SETTING' });
      dispatch(getPremiumSettings());
    })
    .catch(function (error) {
      alert('Update ERROR');
      alert(error);
      dispatch({ type: 'UPDATE_PREMIUM_SETTING_ERROR' });
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(unauthorizedError());
        }
      }
    });
};

export const updateAllPremiumSettings = (settings) => async (dispatch) => {
  try {
    await Promise.all(
      Object.entries(settings).map(([key, value]) => api.put('/config/' + key, { data: value }))
    );
    dispatch({ type: 'UPDATE_PREMIUM_SETTING' });
    alert('Updated');
    dispatch(getPremiumSettings());
  } catch (error) {
    alert('Update ERROR');
    alert(error);
    dispatch({ type: 'UPDATE_PREMIUM_SETTING_ERROR' });
    if (error.response && error.response.status === 401) {
      dispatch(unauthorizedError());
    }
  }
};
